'use client';

import {
	brandName,
	VELOCITY_TEXT_LOGO_DARK_SRC,
	VELOCITY_TEXT_LOGO_LIGHT_SRC,
} from '../../constants/constants';
import { useTheme } from 'next-themes';
import { VelocityTheme } from 'src/environmentVariables/EnvironmentVariableTypes';
import { cj } from 'src/utils/classNames';

const VelocityTextLogo = ({
	className,
	...props
}: React.ImgHTMLAttributes<HTMLImageElement>) => {
	const theme = (useTheme().theme as VelocityTheme) ?? VelocityTheme.dark;
	const src =
		theme === VelocityTheme.light
			? VELOCITY_TEXT_LOGO_LIGHT_SRC
			: VELOCITY_TEXT_LOGO_DARK_SRC;

	return (
		<img
			src={src}
			sizes="66px"
			alt={brandName}
			className={cj('h-full w-[97px] min-w-[66px]', className)}
			{...props}
		/>
	);
};

export default VelocityTextLogo;
